<template>
  <section class="section">
    <h2 class="sub-title">Event Info</h2>
    <dl class="requirements-dl">
      <dt class="item-team">
        {{ Ranking.date[lang] }}
      </dt>
      <dd class="detail-description">
        {{ dataEventRanking.text.event_date }}
      </dd>
    </dl>
    <dl class="requirements-dl">
      <dt class="item-team">
        {{ Ranking.company[lang] }}
      </dt>
      <dd class="detail-description">
        {{ dataEventSummary.summary.company_count.toLocaleString() }}
        {{ Ranking.companies[lang] }}
      </dd>
    </dl>
    <dl class="requirements-dl" v-if="dataEventRanking.text.distance_flag">
      <dt class="item-team">{{ Ranking.distance[lang] }}</dt>
      <dd class="detail-description">
        {{ dataEventSummary.summary.total_distance / 1000 }} km /
        {{
          Math.round(
            (dataEventSummary.summary.total_distance / 1609.344) * 1000
          ) / 1000
        }}
        mile
      </dd>
    </dl>
    <dl class="requirements-dl" v-if="dataEventRanking.text.country_flag">
      <dt class="item-team">{{ Ranking.country[lang] }}</dt>
      <dd class="detail-description">
        {{ dataEventSummary.summary.area_count }}
        {{ Ranking.countries[lang] }}
      </dd>
    </dl>
  </section>
</template>

<script>
import Ranking from "../../../../assets/constants/ranking/ranking.json";
export default {
  props: {
    dataEventRanking: Object,
    dataEventSummary: Object,
  },
  computed: {
    Ranking: function () {
      return Ranking;
    },
    lang: function () {
      return this.$store.state.lang;
    },
  },
  name: "TeamEventInfo",
};
</script>

<style scoped>
.requirements-dl {
  display: flex;
  border-top: solid 1px #999;
  border-left: solid 1px #999;
  border-right: solid 1px #999;
  font-size: 20px;
  &:first-of-type {
    margin: 15px 0 0 0;
  }
  &:last-of-type {
    border-bottom: solid 1px #999;
  }
  .item-team {
    min-width: 420px;
    padding: 18px 20px;
    font-weight: bold;
    border-right: solid 1px #999;
    background-color: #eee;
  }
  .detail-description {
    padding: 18px 23px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/pc/company/ranking/TeamEventInfo.vue